<template>
  <el-dialog
      :title="title"
      :visible.sync="visible"
      :close-on-click-modal="false"
      :before-close="handleBeforeClose"
      custom-class="body_dilog xuanzewuliao"
      append-to-body
      @open="handleOpen"
  >
    <div class="h-rowIn">
      <div class="h-rowBox">
        <div class="h-rowCon yxline">
          <div class="h-formbLine" style="margin-bottom: 1px;">
            <el-form
                :inline="true"
                :model="queryParams"
                class="demo-form-inline h-formBorder"
                @submit.native.prevent
                style="margin-left:-0.5rem"
            >
              <el-form-item label="产品编码/描述" style="width: 55%;">
                <el-input
                    clearable
                    v-model="queryParams.productCodeNameLike"
                    placeholder="请输入产品编码或描述"
                    @keyup.enter.native="handleSearch"
                ></el-input>
              </el-form-item>
              <el-form-item class="h-formBtnOut" style="margin-top:-11px;width:100%;text-align: right;">
                <el-button class="w-tongyi" type="primary" @click="handleSearch">搜索</el-button>
                <el-button class="w-tongyi" type="primary" @click="handleSelect">选择</el-button>
              </el-form-item>
            </el-form>
          </div>

          <!-- 加载状态 -->
          <div class="table-container">
              <el-table
                  max-height="500px"
                  size="mini"
                  ref="multipleTable"
                  :data="tableData"
                  :border="true"
                  tooltip-effect="dark"
                  style="width: 100%"
                  @selection-change="handleSelectionChange"
                  :row-key="row => row.productCode"
              >
                <el-table-column type="selection" fixed width="55"></el-table-column>
                <el-table-column prop="productCode" label="产品编码" :show-overflow-tooltip="true"></el-table-column>
                <el-table-column prop="productName" label="产品名称" :show-overflow-tooltip="true"></el-table-column>
                <el-table-column prop="specificationModel" label="规格型号" :show-overflow-tooltip="true"></el-table-column>
              </el-table>

              <!-- 空状态处理 -->
              <div v-if="tableData.length === 0 && !loading" class="empty-state">
                <el-empty description="暂无匹配的产品数据"></el-empty>
              </div>
            </div>

          <div style="display:flex;justify-content: space-between;flex-direction:row-reverse;margin-top:20px">
            <paginationmin
                :page="queryParams"
                @query="handlePageChange"
                :total="queryParams.total"
            />
          </div>
        </div>
      </div>
    </div>
  </el-dialog>
</template>

<script>
import salesPromotion from "@/api/salesPromotion";

export default {
  name: 'ProductSelectDialog',
  props: {
    // 控制对话框显示/隐藏
    visible: {
      type: Boolean,
      default: false
    },
    // 对话框标题
    title: {
      type: String,
      default: '选择产品'
    },
    // 销售组编码
    saleGroupCode: {
      type: String,
      default: ''
    },
    // 是否允许多选
    multiple: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      // 选中的产品
      selectedProducts: [],
      // 查询参数
      queryParams: {
        productCodeNameLike: '', // 统一参数名，与输入框v-model保持一致
        pageNo: 1,
        pageSize: 10,
        total: 0
      },
      tableData: [],
      // 加载状态
      loading: false,
      loadingText: '加载中...',
      loadingBackground: 'rgba(255, 255, 255, 0.8)',
      // 保存上一次的查询参数，用于优化刷新逻辑
      lastQueryParams: {}
    };
  },
  methods: {
    // 处理选择变化
    handleSelectionChange(selection) {
      this.selectedProducts = selection;
      // 触发选择变化事件，供父组件实时获取选择状态
      this.$emit('selection-change', selection);
    },
    // 搜索产品
    handleSearch() {
      // 重置页码
      this.queryParams.pageNo = 1;
      this.fetchProductList();
    },
    // 处理分页变化
    handlePageChange(params) {
      this.queryParams = { ...this.queryParams, ...params };
      this.fetchProductList();
    },
    // 获取产品列表数据
    async fetchProductList() {
      // 避免重复请求相同参数
      if (this.isSameQueryParams()) {
        return;
      }
      this.loading = true;
      try {
        // 合并查询参数，包含销售组编码
        const params = {
          ...this.queryParams,
          saleGroupCode: this.saleGroupCode
        };
        const res = await salesPromotion.getProductList(params);
        // 验证接口返回格式
        if (res && Array.isArray(res.records)) {
          this.tableData = res.records;
          this.queryParams.total = res.total || 0;
          this.lastQueryParams = { ...params };
        }
      } catch (error) {
        this.$message.error(`加载产品失败: ${error.message || '未知错误'}`);
        this.tableData = [];
        this.queryParams.total = 0;
      } finally {
        this.loading = false;
      }
    },

    // 选择产品
    handleSelect() {
      if (this.selectedProducts.length === 0) {
        this.$message.warning('请先选择产品');
        return;
      }
      // 触发选择事件，将选中的产品传递给父组件
      this.$emit('select', [...this.selectedProducts]);
    },
    // 处理对话框关闭前的逻辑
    handleBeforeClose() {
      this.clearSelection();
      this.$emit('close');
    },
    // 处理对话框打开
    handleOpen() {
      // 当对话框打开时，如果是首次打开或销售组编码变化，重新加载数据
      if (!this.lastQueryParams || this.lastQueryParams.saleGroupCode !== this.saleGroupCode) {
        this.queryParams.pageNo = 1;
        this.fetchProductList();
      }
    },
    // 清除选择
    clearSelection() {
      this.selectedProducts = [];
      if (this.$refs.multipleTable) {
        this.$refs.multipleTable.clearSelection();
      }
    },
    // 清空搜索条件
    resetSearch() {
      this.queryParams.productCodeNameLike = '';
      this.queryParams.pageNo = 1;
      this.fetchProductList();
    },
    // 判断当前查询参数是否与上一次相同
    isSameQueryParams() {
      const currentParams = {
        ...this.queryParams,
        saleGroupCode: this.saleGroupCode
      };
      return JSON.stringify(currentParams) === JSON.stringify(this.lastQueryParams);
    }
  },
  watch: {
    // 监听销售组编码变化，重新加载数据
    saleGroupCode: {
      handler(newVal) {
        if (newVal && this.visible) {
          this.queryParams.pageNo = 1;
          this.fetchProductList();
        }
      },
      immediate: false
    },
    // 监听显示状态变化
    visible(newVal) {
      if (newVal) {
        this.clearSelection();
      }
    }
  },

  // 组件销毁前清除请求
  beforeDestroy() {
    // 如果有请求取消机制，可以在这里实现
  }
};
</script>

<style scoped>
/* 空状态样式 */
.empty-state {
  text-align: center;
  padding: 40px 0;
}

/* 加载状态优化 */
::v-deep .el-loading-mask {
  border-radius: 4px;
}

/* 表格行悬停效果优化 */
::v-deep .el-table__row:hover {
  background-color: #f5f7fa;
}
</style>
